// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.device

import org.multipaz.cbor.DataItem
import org.multipaz.device.DeviceAttestationIos
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Bstr

fun DeviceAttestationIos.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "83NDXMO9flC5Ae0Tjd7Ezy6vjmTwTCTtDhW4FKD_9zw")
val DeviceAttestationIos_cborSchemaId = ByteString(-13, 115, 67, 92, -61, -67, 126, 80, -71, 1, -19, 19, -115, -34, -60, -49, 46, -81, -114, 100, -16, 76, 36, -19, 14, 21, -72, 20, -96, -1, -9, 60)

fun DeviceAttestationIos.Companion.fromCbor(data: ByteArray): DeviceAttestationIos {
    return DeviceAttestationIos.fromDataItem(Cbor.decode(data))
}

val DeviceAttestationIos.Companion.cborSchemaId: ByteString
    get() = DeviceAttestationIos_cborSchemaId

fun DeviceAttestationIos.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "Ios")
    builder.put("blob", Bstr(this.blob.toByteArray()))
    return builder.end().build()
}

fun DeviceAttestationIos.Companion.fromDataItem(dataItem: DataItem): DeviceAttestationIos {
    val blob = ByteString(dataItem["blob"].asBstr)
    return DeviceAttestationIos(
        blob = blob,
    )
}
